






import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import pipeline from '@/pipeline';

export default Vue.extend({
  components: { Icon },
  methods: {
    clickHandler() {
      if (pipeline.initialized) pipeline.prev();
    },
  },
});
